export const CheckboxAlign = {
    Left: 'left',
    Center: 'center',
    Right: 'right',
};
export const CheckboxVerticalAlign = {
    Center: 'center',
    Top: 'top',
};
//# sourceMappingURL=types.js.map